import { CommonModule } from "@angular/common";
import { ModuleHeightDirective } from "./directives/module-height.directive";
import { SafeUrlPipe } from "./pipes/safe-url.pipe";
import { FormatedNumberPipe } from "./pipes/formated-number.pipe";
import { BulletsDirective } from "./rubrics/directives/texts/bullets/bullets.directive";
import { TitleDirective } from "./rubrics/directives/texts/title/title.directive";
import { BodyTextDirective } from "./rubrics/directives/texts/body-text/body-text.directive";
import { AudioDirective } from "./rubrics/directives/audio/audio.directive";
import { HtmlAssetDirective } from "./rubrics/directives/html-asset/html-asset.directive";
import { ImageButtonDirective } from "./rubrics/directives/buttons/image-button/image-button.directive";
import { BackgroundImageDirective } from "./rubrics/directives/backgrounds/background-image.directive";
import { TranscriptTextDirective } from "./rubrics/directives/texts/transcript-text/transcript-text.directive";
import { InstructionPopupDirective } from "./rubrics/directives/popups/instruction-popup/instruction-popup.directive";
import { SubTitleDirective } from "./rubrics/directives/texts/sub-title/sub-title.directive";
import { SafeHtmlPipe } from "./pipes/safe-html.pipe";
import { VideoDirective } from "./rubrics/directives/video/video.directive";
import { VideowithtranscriptDirective } from "./rubrics/directives/video/videowithtranscript/videowithtranscript.directive";
import { FeedbackIconDirective } from "./rubrics/directives/feedback-icon/feedback-icon";
import { FeedbackBottomDirective } from "./rubrics/directives/texts/feedback-bottom/feedback-bottom";
import { OptionTextDirective } from "./rubrics/directives/texts/option-text/option-text.directive";
import { McqDirective } from "./rubrics/directives/quiz/mcq/mcq.directive";
import { QuizDirective } from "./rubrics/directives/quiz/quiz.directive";
import { QuizFeedbackDirective } from "./rubrics/directives/feedback/quiz-feedback/quiz-feedback.directive";
import { PageTitleDirective } from "./rubrics/directives/texts/page-title/page-title.directive";
import { IndexTextDirective } from "./rubrics/directives/texts/index-text/index-text.directive";
import { StateSpecificContentComponent } from "./core/views/state-specific-content/state-specific-content.component";
import { FeedbackBoxDirective } from "./rubrics/directives/feedback/feedback-box/feedback-box.directive";
import { AlertDirective } from "./rubrics/directives/alert/alert";
import { ScreennavigatorwithtranscriptDirective } from "./rubrics/directives/texts/screennavigatorwithtranscript/screennavigatorwithtranscript.directive";
import { NgIncludeDirective } from "./rubrics/directives/ng-include/ng-include.directive";
import { DropdownDirective } from "./directives/dropdown/dropdown.directive";
import { LogoImageDirective } from "./directives/logo-image/logo-image.directive";
import { DraggableDirective } from "./rubrics/directives/draggable/draggable.directive";
import { DropableDirective } from "./rubrics/directives/dropable/dropable.directive";
import { VectorQuizDirective } from "./rubrics/directives/vector-quiz/vector-quiz.directive";
import { VectorMcqDirective } from "./rubrics/directives/vector-quiz/vector-mcq/vector-mcq.directive";
import { VectorOptionTextDirective } from "./rubrics/directives/texts/vector-option-text/vector-option-text.directive";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ToggleTranscriptTextDirective } from "./rubrics/directives/texts/toggle-transcript-text/toggle-transcript-text.directive";
import { SuccessorNotificationDirective } from "./rubrics/directives/notifications/successor/successor-notification.directive";
import { RemediesComponent } from "./directives/remedies/remedies.component";
import { RemediesAcpComponent } from "./directives/adaptive/remedies/remedies.component";
import { VideoWithCustomControlsDirective } from "./rubrics/directives/video_custom_controls/video_custom_controls";
import { AudioWithCustomControlsDirective } from "./directives/audio_custom_controller/audio_custom_controller.directive";

import { ImageNavigatorDirective } from "./rubrics/directives/image-navigator/image-navigator.directive";
import { DefinitionContentDirective } from "./rubrics/directives/definition/definition.directive";
import { StateSpecificContentAdaptiveComponent } from "./core/views/adaptive/state-specific-content/state-specific-content.adaptive.component";

import { PlayBackSpeedControllerDirective } from "./directives/playback-speed-controller/playback-speed-controller";
import { TrapfocusDirective } from "./directives/trapfocus/trapfocus.directive";
import { QuizAcpComponent } from "./rubrics/directives/adaptive/quiz-acp/quiz-acp.component";
import { ZoomOptionComponent } from "./directives/adaptive/zoom-option/zoom-option.component";
import { HandleAnchorClickDirective } from "./directives/handle-anchor-click.directive";

@NgModule({
	declarations: [
		ModuleHeightDirective,
		SafeUrlPipe,
		FormatedNumberPipe,
		BulletsDirective,
		StateSpecificContentComponent,
		TitleDirective,
		BodyTextDirective,
		AudioDirective,
		HtmlAssetDirective,
		ImageButtonDirective,
		BackgroundImageDirective,
		TranscriptTextDirective,
		InstructionPopupDirective,
		SubTitleDirective,
		SafeHtmlPipe,
		VideoDirective,
		VideowithtranscriptDirective,
		FeedbackIconDirective,
		FeedbackBottomDirective,
		OptionTextDirective,
		McqDirective,
		QuizDirective,
		QuizFeedbackDirective,
		PageTitleDirective,
		IndexTextDirective,
		FeedbackBoxDirective,
		AlertDirective,
		ScreennavigatorwithtranscriptDirective,
		NgIncludeDirective,
		DropdownDirective,
		LogoImageDirective,
		DraggableDirective,
		DropableDirective,
		VectorQuizDirective,
		VectorMcqDirective,
		VectorOptionTextDirective,
		ToggleTranscriptTextDirective,
		SuccessorNotificationDirective,
		RemediesComponent,
		RemediesAcpComponent,
		VideoWithCustomControlsDirective,
		AudioWithCustomControlsDirective,
		ImageNavigatorDirective,
		DefinitionContentDirective,
		StateSpecificContentAdaptiveComponent,
		PlayBackSpeedControllerDirective,
		TrapfocusDirective,
		QuizAcpComponent,
		ZoomOptionComponent,
		HandleAnchorClickDirective
	],
	imports: [CommonModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	exports: [
		ModuleHeightDirective,
		SafeUrlPipe,
		FormatedNumberPipe,
		BulletsDirective,
		StateSpecificContentComponent,
		TitleDirective,
		BodyTextDirective,
		AudioDirective,
		HtmlAssetDirective,
		ImageButtonDirective,
		BackgroundImageDirective,
		TranscriptTextDirective,
		InstructionPopupDirective,
		SubTitleDirective,
		SafeHtmlPipe,
		VideoDirective,
		VideowithtranscriptDirective,
		FeedbackIconDirective,
		FeedbackBottomDirective,
		OptionTextDirective,
		McqDirective,
		QuizDirective,
		QuizFeedbackDirective,
		PageTitleDirective,
		IndexTextDirective,
		FeedbackBoxDirective,
		AlertDirective,
		ScreennavigatorwithtranscriptDirective,
		NgIncludeDirective,
		DropdownDirective,
		LogoImageDirective,
		DraggableDirective,
		DropableDirective,
		VectorQuizDirective,
		VectorMcqDirective,
		VectorOptionTextDirective,
		ToggleTranscriptTextDirective,
		SuccessorNotificationDirective,
		RemediesComponent,
		RemediesAcpComponent,
		VideoWithCustomControlsDirective,
		AudioWithCustomControlsDirective,
		ImageNavigatorDirective,
		DefinitionContentDirective,
		StateSpecificContentAdaptiveComponent,
		PlayBackSpeedControllerDirective,
		TrapfocusDirective,
		QuizAcpComponent,
		ZoomOptionComponent,
		HandleAnchorClickDirective
	],
})
export class RCPCommonModule {}
